import React from 'react';
import { Section } from './Section';
export function HowItWorksSection() {
  const steps = [{
    day: 'Día 1',
    title: 'Desinflama',
    desc: 'Empiezas a darle un descanso a tu cuerpo con pasos simples y alimentación guiada.'
  }, {
    day: 'Día 2',
    title: 'Reorganiza',
    desc: 'Sigues una estructura práctica para sentir más estabilidad y menos pesadez.'
  }, {
    day: 'Día 3',
    title: 'Reafirma',
    desc: 'Cierras el proceso con una rutina fácil para mantener la sensación de ligereza.'
  }];
  return <Section className="bg-cream" data-id="element-95">
      <h2 className="font-serif text-3xl md:text-4xl text-forest font-bold mb-12 text-center" data-id="element-96">
        Cómo funciona el protocolo
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-97">
        {steps.map((step, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-md border border-sage text-center relative overflow-hidden" data-id="element-98">
            <div className="absolute top-0 left-0 w-full h-2 bg-gold" data-id="element-99"></div>
            <span className="text-gold font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-100">
              {step.day}
            </span>
            <h3 className="font-serif text-2xl font-bold text-forest mb-4" data-id="element-101">
              {step.title}
            </h3>
            <p className="text-gray-600" data-id="element-102">{step.desc}</p>
          </div>)}
      </div>
    </Section>;
}